module.exports = __webpack_public_path__ + "img/award04_06.959d4a39.png";